import type { ChatPromptContextEntity } from '@flux/iara-core/prompt-context';

/**
 * Rótulo publicado por uma tela, sempre chaveado pelo id da entidade — assim um
 * rótulo que sobrou de outro card nunca aparece no lugar do atual.
 */
export interface IaraPublishedLabel {
  id: string;
  label: string;
}

/**
 * Entidade publicada por inteiro por telas que **não deixam rastro na URL** — o
 * caso da aprovação, cujo dialog não escreve query param. Diferente de
 * `IaraPublishedLabel`, aqui a própria presença da entidade vem do publish, então
 * o id é obrigatório e a tela é dona do ciclo de vida.
 */
export type IaraPublishedEntity = ChatPromptContextEntity & { id: string };

/**
 * Valor de `PanelEnum.CARD_DETAIL` (`@core/services/panel.service`) replicado aqui
 * de propósito: `panel.service` importa `CardDetailDialogComponent`, que por sua vez
 * publica neste contexto — importar o enum fecharia um ciclo de módulos passando
 * por dentro de um serviço `providedIn: 'root'`.
 */
export const IARA_CARD_DETAIL_PANEL = 'card-detail';

/**
 * Query params que o modal de tarefa escreve (`CardTaskService.FLAGS`), replicados
 * pelo mesmo motivo do painel acima: o service da tarefa vive dentro do modal de
 * card, que publica aqui.
 */
export const IARA_TASK_PARAMS = ['view-card-task', 'manage-card-task'] as const;

/** Rótulos legíveis por `view_mode` da tela de fluxo. */
export const IARA_VIEW_MODE_LABELS: Record<string, string> = {
  analytics: 'Relatórios',
  board: 'Quadro',
  documentation: 'Documentação',
  reports: 'Formulários',
  reviews: 'Aprovações',
  solicitations: 'Solicitações',
  table: 'Tabela',
  tasks: 'Tarefas',
};
